import { useEffect } from "react";

import { USER_CANCELLED_MESSAGE } from "../../errors/TransactionError";
import type { TransactionState } from "../../types/transaction";

/**
 * Auto-dismiss the error UI when the user rejects in their wallet.
 *
 * Cancelling is an intentional action — landing on a "Buy/Stake/Unstake/
 * Withdraw Failed → Return to X" screen treats it like a failure. Instead,
 * detect the canonical USER_REJECTED message and fire `onDismiss` so the
 * form snaps straight back to its input view (with the typed value
 * preserved, when the caller's dismiss handler supports it).
 *
 * Other failure modes ("Transaction failed", "Insufficient funds", etc.)
 * keep the existing recovery UI — the user needs to see why.
 */
export function useAutoDismissUserCancel(executeState: TransactionState, onDismiss: () => void): void {
    useEffect(() => {
        if (executeState.isError && executeState.errorMessage === USER_CANCELLED_MESSAGE) {
            onDismiss();
        }
    }, [executeState.isError, executeState.errorMessage, onDismiss]);
}
